import styled from 'styled-components'
import { ButtonPink } from 'components/Button'

export const Grid = styled.div`
  display: grid;
  grid-gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
`

export const Card = styled.div`
  background-color: ${({ theme }) => theme.bg3};
  border-radius: 24px;
  padding: 16px;
  position: relative;
`

export const CardTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 6px;
  padding-top: 20px;
`

export const CardContent = styled.div`
  font-size: 16px;
`

export const ResponsiveButtonPink = styled(ButtonPink)`
  margin: auto;
  width: 100%;
`

export const Flexer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NoAssetsTitle = styled.div`
  font-family: 'Rubik';
  font-size: 24px;
  font-weight: 700;
  margin-top: 48px;
`

export const RedirectText = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-top: 16px;

  a {
    color: #d06cff;
    text-decoration: none;
  }
`
